import _ = require('underscore');
import angular = require('angular');
import { IAudienceOffer, IGroupAudience, IPlaceAudience } from '../../models';


interface IViewAudienceModel {
    title: string;
    items: string[];
}
interface IViewGenderModel {
    title: string;
    item: string;
}

interface IAge {
    id: number;
    item: string;
    title: string;
}

class AudienceViewComponent {
    static $inject = ['$translate'];
    audience: IAudienceOffer;
    rules = [];

    private or = this.$translate.instant('op_or');
    private and = this.$translate.instant('op_and');
    private simpleTemplate = 'simpleAudienceView';
    private ageTemplate = 'ageAudienceView';
    private title = 'title';
    private name = 'name';
    private underAges: any[];
    private overAges: any[];

    private model = {
        ages: {
            template: this.ageTemplate,
            title: {
                over: this.$translate.instant('op_is_aged_over'),
                under: this.$translate.instant('op_is_aged_under')
            },
            operator: this.and,
            items: <IViewGenderModel[][]>[],
            comparator: this.or,
        },
        genders: <IViewAudienceModel>{
            template: this.simpleTemplate,
            operator: this.and,
            title: this.$translate.instant('op_is_gender'),
            items: <string[]>[],
            comparator: this.or,
        },
        interests: <IViewAudienceModel>{
            template: this.simpleTemplate,
            operator: this.and,
            comparator: this.or,
            title: this.$translate.instant('op_likes_interest'),
            items: <string[]>[]
        },
        categories: <IViewAudienceModel>{
            template: this.simpleTemplate,
            operator: this.and,
            comparator: this.or,
            title: this.$translate.instant('op_is_in_category'),
            items: <string[]>[]
        },
        places: <IViewAudienceModel>{
            template: this.simpleTemplate,
            operator: this.and,
            comparator: this.or,
            title: this.$translate.instant('op_is_in_place'),
            items: <string[]>[]
        }
    };

    private ages = [
        { id: 1, min: null, max: 17 },
        { id: 2, min: 18, max: 20 },
        { id: 3, min: 21, max: 29 },
        { id: 4, min: 30, max: 39 },
        { id: 5, min: 40, max: 50 },
        { id: 6, min: 51, max: null }
    ];

    constructor(private $translate: angular.translate.ITranslateService) {

        this.overAges = this.getOverAges();
        this.underAges = this.getUnderAges();
    }

    $onChanges(changes: any) {

        if ((changes.change || changes.audience && changes.audience.currentValue) && this.audience) {

            this.mapModel();
        }
    }

    private mapModel() {
        this.rules = [];
        this.model.interests.items = this.mapGroup(this.audience.interests, false);
        this.model.genders.items = this.mapGroup(this.audience.genders, false);
        this.model.categories.items = this.mapCategoriesGroup(this.audience.categories, true);
        this.model.places.items = this.mapPlacesGroup(this.audience.places, true);
        this.model.ages.items = this.mapAgeGroup(this.audience.ages);

        if (!_.isEmpty(this.model.interests.items)) {
            this.rules.push(this.model.interests);
        }
        if (!_.isEmpty(this.model.genders.items)) {
            this.rules.push(this.model.genders);
        }

        if (!_.isEmpty(this.model.ages.items)) {
            this.rules.push(this.model.ages);
        }

        if (!_.isEmpty(this.model.places.items)) {
            this.rules.push(this.model.places);
        }
        if (!_.isEmpty(this.model.categories.items)) {
            this.rules.push(this.model.categories);
        }
    }

    private mapGroup(group: IGroupAudience, showAll: boolean) {
        if (group.enabled) {
            let selected = _.where(group.items, { selected: true });
            return showAll ? _.pluck(selected, this.title) : _.size(selected) === _.size(group.items) ? [] : _.pluck(selected, this.title);
        }
        return [];
    }

    private mapCategoriesGroup(group: IGroupAudience, showAll: boolean) {
        if (group.enabled) {
            let selected = _.where(group.items, { selected: true });
            return showAll ? _.pluck(selected, this.title) : _.size(selected) === _.size(group.items) ? [] : _.pluck(selected, this.title);
        }
        return [];
    }
    private mapPlacesGroup(group: IGroupAudience, showAll: boolean) {
        if (group.enabled) {
            let selected = _.where(<IPlaceAudience[]>group.items, { selected: true });
            let maps = _.map(selected, (item) => `${item.title} (${item.town})`);
            return showAll ? maps : _.size(selected) === _.size(group.items) ? [] : maps;
        }
        return [];
    }

    private mapAgeGroup(audience: IGroupAudience) {
        let items = <IViewGenderModel[][]>[];
        let genderIDs: number[] = [];
        if (audience.enabled) {
            let selected = _.where(audience.items, { selected: true });
            genderIDs = _.size(selected) === _.size(audience.items) ? [] : _.pluck(selected, 'id');
        }
        if (_.isEmpty(genderIDs)) {
            return items;
        }

        let ages = _.map(genderIDs, (id) => _.findWhere(this.ages, { id: id }));

        let groups = [];
        let group = [];
        let prev = 0;
        for (var i = 0; i < ages.length; i++) {
            let age = ages[i];
            if (_.size(group) === 0 || prev + 1 === age.id) {
                group.push(age.id);
            } else {
                groups.push(group);
                group = [age.id];
            }
            prev = age.id;
        }

        groups.push(group);
        let ageAudienceArray = [];
        _.forEach(groups, (group: number[]) => {
            ageAudienceArray.push(this.getAgeAudienceGroup(group));
        });

        items = _.map(<IAge[][]>ageAudienceArray, (ageAudience) => {
            return _.map(ageAudience, (age) => {
                return {
                    title: age.title,
                    item: age.item
                };
            });
        });
        return items;
    }

    private getAgeAudienceGroup(group: number[]) {
        var min: number = _.first(group),
            max: number = _.last(group);

        var hasGtRule = min >= _.first(this.underAges).id,
            hasLtRule = max <= _.last(this.overAges).id;

        min--;
        max++;

        if (hasGtRule && hasLtRule) {
            return [_.findWhere(this.overAges, { id: min }), _.findWhere(this.underAges, { id: max })];
        } else if (hasGtRule) {
            return [_.findWhere(this.overAges, { id: min })];
        } else if (hasLtRule) {
            return [_.findWhere(this.underAges, { id: max })];
        } else {
            throw new Error('Invalid age rule group');
        }
    }

    private getOverAges() {
        return _.map(_.filter(<any[]>this.ages, (age) => age.max), (age) => {
            return <IAge>{
                id: age.id,
                item: `${age.max} ${this.$translate.instant('years')}`,
                title: this.$translate.instant('op_is_aged_over')
            };
        }
        );
    }

    private getUnderAges() {
        return _.map(_.filter(<any[]>this.ages, (age) => age.min), (age) => {
            return <IAge>{
                id: age.id,
                item: `${age.min} ${this.$translate.instant('years')}`,
                title: this.$translate.instant('op_is_aged_under')
            };
        }
        );
    }
}

angular.module('naut').component('audienceView', {
    template: require('./audience-view.html'),
    controller: AudienceViewComponent,
    controllerAs: '$vm',
    bindings: {
        audience: '<',
        change: '<'
    },
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/audience-view/audience-view.ts